<template>
  <div class="tw:bg-green-200 tw:py-[60px]">
    <ContainerLayout class="tw:flex tw:flex-col tw:lg:flex-row tw:gap-x-[60px]">
      <div class="tw:w-full tw:lg:w-1/3 tw:mb-6 tw:lg:mb-0">
        <h1
          class="tw:text-[28px] tw:leading-[35px] tw:md:text-[44px] tw:md:leading-[55px]"
          v-html="$t('rc_product_page_benefits_header')"
        />
      </div>
      <div class="tw:w-full tw:lg:w-2/3 tw:flex tw:flex-col tw:md:flex-row tw:gap-y-6 tw:gap-x-8">
        <div
          v-for="benefit in benefits"
          :key="benefit.id"
          class="tw:flex tw:flex-col tw:gap-y-3"
          :data-testid="`rc-benefit-${benefit.id}`"
        >
          <h3 :data-testid="`rc-benefit-title-${benefit.id}`" class="tw:font-bold tw:text-2xl">
            {{ $t(benefit.title) }}
          </h3>
          <p :data-testid="`rc-benefit-text-${benefit.id}`" class="tw:text-sm tw:md:text-base">
            {{ $t(benefit.text) }}
          </p>
        </div>
      </div>
    </ContainerLayout>
  </div>
</template>
<script setup>
import ContainerLayout from '@/layouts/ContainerLayout.vue'
import { ref } from 'vue'

const benefits = ref([
  { id: 0, title: 'rc_product_page_benefits_1_header', text: 'rc_product_page_benefits_1_text' },
  {
    id: 1,
    title: 'rc_product_page_benefits_2_header',
    text: 'rc_product_page_benefits_2_text',
  },
  { id: 2, title: 'rc_product_page_benefits_3_header', text: 'rc_product_page_benefits_3_text' },
])
</script>
